import config from "@/config/config";
import type { K3Credentials, K3Session } from "@/core/auth/adapter";
import type { AuthAdapter } from "@k3-tech/react-kit";
import { TanstackDevtools } from "@tanstack/react-devtools";
import { Outlet, createRootRouteWithContext, redirect } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";

export const Route = createRootRouteWithContext<{
  authAdapter: AuthAdapter<unknown, string, string, K3Session, K3Credentials>
}>()({
  beforeLoad({ location, context }) {
    const state = context.authAdapter.getState();
    if (location.pathname.startsWith("/admin")) {
      if (state.status !== "authenticated") {
        const redirectTo = location.href ?? "/admin";
        throw redirect({ to: "/login", search: { redirect: redirectTo } });
      }
    }
  },
  component: () => (
    <>
      <Outlet />
      {config.ENABLE_TANSTACK_DEVTOOLS && (
        <TanstackDevtools
          config={{
            position: "bottom-right",
          }}
          plugins={[
            {
              name: "Tanstack Router",
              render: <TanStackRouterDevtoolsPanel />,
            },
          ]}
        />
      )}
    </>
  ),
});
